import { useAuth } from '../context/AuthContext';

export const useUser = () => {
  const { user, updateUser, ...auth } = useAuth();
  
  return {
    ...auth,
    user,
    updateUser,
    // Métodos helpers
    getUserName: () => user ? `${user.nombres}` : '',
    getUserEmail: () => user?.email || '',
    isUserActive: () => user?.estado === 'activo'
  };
};